import { AuthClient as Client } from "./client";

export * from "./constants";
export * from "./types";
export * from "./utils/crypto";

export const AuthClient = Client;
export default Client;
